import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import styled from '@emotion/styled';

const FieldInfoButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  color: var(--productPrimary);
`;

const LoginMethodTooltip = () => {
  const { t } = useTranslation('common');

  const tooltipText = t(
    'Make sure you use the same login method and email you used when creating your account. You cannot sign in with a different method'
  );

  return (
    <Tooltip title={tooltipText} trigger={['hover', 'focus']}>
      <FieldInfoButton type="button" aria-label={t('Login method information')} data-testid="login-method-tooltip">
        <InfoCircleOutlined aria-hidden="true" />
      </FieldInfoButton>
    </Tooltip>
  );
};

export default LoginMethodTooltip;
